import Prismic from '@prismicio/client';

const accessToken =
  'MC5YdGxaRGhBQUFCNEFOcktG.77-977-977-977-9ZO-_vVPvv70d77-977-977-977-977-977-9ee-_vWDvv70l77-9RO-_vQTvv71aU--_vUdt77-9RQ'; // This is where you would add your access token for a Private repository
const apiEndpoint = 'https://xometry-marketing.cdn.prismic.io/api/v2';

const PrismicClient = Prismic.client(apiEndpoint, { accessToken });

export default PrismicClient;
